import { render } from "./IntegrationSlackSettings.vue?vue&type=template&id=0f0d9dd0&scoped=true"
import script from "./IntegrationSlackSettings.vue?vue&type=script&lang=js"
export * from "./IntegrationSlackSettings.vue?vue&type=script&lang=js"

import "./IntegrationSlackSettings.vue?vue&type=style&index=0&id=0f0d9dd0&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0d9dd0"]])

export default __exports__